export default __webpack_public_path__ + "0b5d3e58d88b916b0dea1b13b39fe9a9.svg";